import { render, staticRenderFns } from "./Promotion_set.vue?vue&type=template&id=00984f26&scoped=true&"
import script from "./Promotion_set.vue?vue&type=script&lang=js&"
export * from "./Promotion_set.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_set.vue?vue&type=style&index=0&id=00984f26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00984f26",
  null
  
)

export default component.exports